import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyle from './styles/globalStyles';
import { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import nb from 'date-fns/locale/nb';
import 'react-datepicker/dist/react-datepicker.css';

import {
  FigtreeGlobalFonts,
  InterGlobalFonts,
  HedvigLettersSansGlobalFonts,
  NotoSansGlobalFonts,
  PoppinsGlobalFonts,
} from './fonts';
import { useFnol } from './context';
import './styles/datepicker-fix.css';
import { PageContainer } from './components';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';

registerLocale('sv', sv);
registerLocale('no', nb);

const App = () => {
  const {
    fnolTemplates,
    clearFnolContext,
    getFnolTemplates,
    setFnolCategories,
  } = useFnol();

  const { t } = useTranslation();

  const languages = {
    NO: 'nb',
    SE: 'sv',
  };

  const onResize = () => {
    window.parent.postMessage(
      {
        type: 'resize',
        height: document.body.scrollHeight,
      },
      '*'
    );
  };

  useEffect(() => {
    getFnolTemplates();

    return () => {
      clearFnolContext();
    };
  }, []);

  useEffect(() => {
    if (fnolTemplates.length > 0) {
      setFnolCategories();
      i18n.changeLanguage(languages[fnolTemplates[0].locale]);
    }
  }, [fnolTemplates]);

  useEffect(() => {
    onResize();
    new ResizeObserver(_ => onResize()).observe(document.body);
  }, []);

  document.title = t('pageTitle');

  return (
    <Router basename='/fnol'>
      <PageContainer>
        <FigtreeGlobalFonts />
        <InterGlobalFonts />
        <HedvigLettersSansGlobalFonts />
        <NotoSansGlobalFonts />
        <PoppinsGlobalFonts />
        <GlobalStyle />
      </PageContainer>
    </Router>
  );
};

export default App;
